import MinorButton from "@hudson/ui/components/FormFields/ButtonMinor";
import styles from "@hudson/ui/styles/Form.module.css";
import classNames from "classnames";

export interface Action {
  disabled?: boolean;
  icon?: JSX.Element;
  label: string;
  loading?: boolean;
  onClick: () => any;
}

function Actions({ actions }: { actions: Action[] }): JSX.Element {
  return (
    <span className="isolate inline-flex rounded-md shadow-sm">
      <MinorButton
        key={actions[0].label}
        icon={actions[0].icon}
        onClick={() => actions[0].onClick()}
        rounded={actions.length > 1 ? "left" : "both"}
      >
        {actions[0].label}
      </MinorButton>

      {actions.slice(1).map((action) => (
        <MinorButton
          className="-ml-px"
          key={action.label}
          icon={action.icon}
          onClick={() => action.onClick()}
          rounded="right"
        >
          {action.label}
        </MinorButton>
      ))}
    </span>
  );
}

export default Actions;
